module.exports = __webpack_public_path__ + "static/media/mgo_3_3_ws.05ce5b2f.pdf";